export const RANKING_TYPES = {
  districts: {
    label: 'Top Districts',
    nameHeader: 'District',
    helpText: 'Ranks the most engaged districts across the platform for the selected reporting period.'
  },
  schools: {
    label: 'Top Schools',
    nameHeader: 'School',
    helpText: 'Ranks the most engaged schools within the selected district and reporting period.'
  },
  students: {
    label: 'Top Students',
    nameHeader: 'Student',
    helpText: 'Ranks the most engaged students within the selected filters and reporting period.'
  }
};

export const getRankingRows = (rankings, type) => {
  if (Array.isArray(rankings)) {
    return rankings;
  }

  return rankings?.[type]
    ?? rankings?.[`${type}Ranking`]
    ?? rankings?.[`${type}Rankings`]
    ?? [];
};

export const getName = (row, type, ferpaEnabled = true) => {
  if (type === 'students' && !ferpaEnabled) {
    return 'name hidden';
  }

  const singularType = type.slice(0, -1);
  return row?.[`${singularType}Name`] ?? row?.name ?? '-';
};

export const getMetric = (row, ...keys) => keys.reduce(
  (value, key) => value ?? row?.[key],
  undefined
) ?? 0;

export const formatMetric = (value) => Number(value || 0).toLocaleString(undefined, {
  maximumFractionDigits: 1
});

